import angular from 'angular';

import ExtensionsBuilderRowComponent from './extensions-builder-row.component';

const ExtensionsBuilderRowModule = angular
    .module('control-room.commons.form.components.extensions-builder-row', [])
    .component('crExtensionsBuilderRow', ExtensionsBuilderRowComponent);

export default ExtensionsBuilderRowModule;
